export enum AlertType {

  Info = 'Info',
  Error = 'Danger',
  Success = 'Success',
  Warning = 'Warning',

}

export interface Alert {

  message: string;
  type: AlertType;
  remindableKey: string;
  duration: number;

}
